import { createContext, useContext, useState } from "react";

const GlobalContext = createContext(null);

const GlobalContextWrapper = ({ children }) => {
  const [globalData, setGlobalData] = useState({
    // loggedIn: isCookieAuthInfoPresent(),
    // leadId: getLeadFromCookie().leadId,
    loggedIn: "",
    authToken: "",
  });

  return (
    <GlobalContext.Provider value={{ globalData, setGlobalData }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => {
  const data = useContext(GlobalContext);
  return data;
};

export default GlobalContextWrapper;
